import { useQueryClient } from '@tanstack/react-query';
import { AlertDialog, toast } from '@round/creatorbase-ui';
import { creatorbase } from '@round/api';
import { useDeletePoolMutation } from '@round/creatorbase-helpers/api-hooks';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    pool: creatorbase.Pool | null;
};

export const DeletePoolModal = ({ isOpen, onClose, pool }: Props) => {
    const queryClient = useQueryClient();
    const { deleteOne, isLoading } = useDeletePoolMutation(pool?.id, queryClient);

    const handleOpenChange = (open: boolean) => {
        if (!open && !isLoading) {
            onClose();
        }
    };

    const handleDelete = () => {
        if (!pool) {
            return;
        }

        deleteOne(undefined, {
            onSuccess: () => {
                toast.info('Pool deleted');
                onClose();
            },
            onError: () => {
                toast.error('Could not delete pool');
            },
        });
    };

    return (
        <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
            <AlertDialog.Content size="sm">
                <AlertDialog.Header>
                    <AlertDialog.Title>Delete pool?</AlertDialog.Title>
                    <AlertDialog.Description>This permanently deletes “{pool?.name}”.</AlertDialog.Description>
                </AlertDialog.Header>
                <AlertDialog.Footer>
                    <AlertDialog.Cancel variant="outline" size="sm" disabled={isLoading}>
                        Cancel
                    </AlertDialog.Cancel>
                    <AlertDialog.Action
                        variant="destructive"
                        size="sm"
                        onClick={handleDelete}
                        disabled={!pool || isLoading}
                        isLoading={isLoading}
                    >
                        Delete pool
                    </AlertDialog.Action>
                </AlertDialog.Footer>
            </AlertDialog.Content>
        </AlertDialog>
    );
};
